<div class="my-24 flex flex-col gap-24 p-4 md:my-28 md:gap-28">
  <!-- Hero -->
  <app-live-updates-hero-section id="hero"></app-live-updates-hero-section>
  <!-- Video -->
  <app-video-section
    id="video"
    src="assets/videos/live-updates-demo.mp4"
  ></app-video-section>
  <!-- Social Proof -->
  <app-customer-logo-section id="customers"></app-customer-logo-section>
  <!-- How it works -->
  <app-live-updates-how-it-works-section
    id="how-it-works"
  ></app-live-updates-how-it-works-section>
  <!-- Features -->
  <app-live-updates-features-section
    id="features"
  ></app-live-updates-features-section>
  <!-- Statistics -->
  <app-live-updates-statistics-section
    id="statistics"
  ></app-live-updates-statistics-section>
  <!-- Integration example -->
  <app-live-updates-integration-section
    id="integration"
  ></app-live-updates-integration-section>
  <!-- App Icons -->
  <app-app-icon-section id="app-icons"></app-app-icon-section>
  <!-- Testimonials -->
  <app-testimonials-section id="testimonials"></app-testimonials-section>
  <!-- Blog -->
  <app-blog-section id="blog" [posts]="blogPosts"></app-blog-section>
  <!-- FAQ -->
  <app-live-updates-faq-section id="faq"></app-live-updates-faq-section>
  <!-- CTA -->
  <app-live-updates-cta-section id="cta"></app-live-updates-cta-section>
</div>
